module.exports = __webpack_public_path__ + "img/DukePic.b6e4232d.png";